import { useDispatch } from 'react-redux';
import React, { useLayoutEffect, useEffect } from 'react';

import { togglePageRendered, togglePageRendering } from '../store/actions';

export const withPageEvent = (WrappedComponent) => (props) => {
    const { isPageInPopup, isLoading } = props;
    const dispatch = useDispatch();
    const PAGE_RENDERED_TIMEOUT = window.Playtech.Variables.pageRenderTimeout ?? 500;

    useLayoutEffect(() => {
        if (isPageInPopup || isLoading) {
            return;
        }

        dispatch(togglePageRendering(true));
    }, [dispatch, isLoading, isPageInPopup]);

    useEffect(() => {
        if (isPageInPopup || isLoading) {
            return;
        }

        setTimeout(() => {
            dispatch(togglePageRendering(false));
            dispatch(togglePageRendered(true));
        }, PAGE_RENDERED_TIMEOUT);

        return () => {
            dispatch(togglePageRendered(false));
        };
    }, [dispatch, isLoading, isPageInPopup, PAGE_RENDERED_TIMEOUT]);

    return (
        <WrappedComponent {...props} />
    );
};
